<div class="page-header">
  <app-page-title></app-page-title>
</div>
<div class="user-certificate-container">
  <div class="search-section">
    <div class="search-row row g-2 g-md-3 align-items-center">
      <div class="col-12 col-md order-2 order-md-1">
        <div class="search-wrapper">
          <i class="bi bi-search search-icon"></i>
          <input id="search-input"
                 type="text"
                 class="form-control"
                 placeholder="พิมพ์เลขที่ใบรับรองเพื่อค้นหา"
                 [(ngModel)]="searchTerm"
                 (keyup.enter)="searchCertificate()">
        </div>
      </div>
      <div class="col-12 col-md-auto order-1 order-md-2 d-flex gap-2">
        <button class="btn btn-outline-primary-accent w-100 w-md-auto"
                type="button"
                [disabled]="isSyncing"
                (click)="syncCertificates()">
          @if (isSyncing) {
            <span class="spinner-border spinner-border-sm" role="status" aria-label="Syncing"></span>
          } @else {
            <i class="bi bi-arrow-repeat"></i>
          }
          ซิงค์ใบรับรอง
        </button>
        <button class="btn btn-primary w-100 w-md-auto" (click)="addCertificate()">
          <i class="bi bi-plus-lg"></i>
          เพิ่มใบรับรอง
        </button>
      </div>
    </div>
  </div>

  @if (isLoading) {
    <div class="empty-state">
      <div class="empty-icon">
        <div class="spinner-border text-primary-accent" role="status" aria-label="Loading"></div>
      </div>
      <h4>กำลังโหลดข้อมูลใบรับรอง</h4>
    </div>
  } @else if (certificates.length === 0) {
    <div class="empty-state">
      <div class="empty-icon">
        <i class="bi bi-inbox"></i>
      </div>
      <h4>ไม่พบใบรับรอง</h4>
      <p>ยังไม่มีใบรับรองในระบบ</p>
      <button class="btn btn-primary" (click)="addCertificate()">
        <i class="bi bi-plus-lg"></i>
        เพิ่มใบรับรองแรก
      </button>
    </div>
  } @else {
    <div class="business-card-secion">
      <div class="business-card-list">
        @for (cert of certificates; track cert.id) {
          <article class="card certificate-card">
            <div class="card-body">
              <div class="business-item">
                <div class="business-avatar" aria-hidden="true">
                  <i class="bi bi-patch-check"></i>
                </div>
                <div class="business-content">
                  <div class="business-top">
                    <div class="business-title-group">
                      <h6 class="business-name">
                        <span class="meta-label">เลขที่ใบรับรอง:</span>
                        <span class="meta-value">{{ cert.certificateNo }}</span>
                      </h6>
                    </div>
                    <div class="business-actions">
                      <span class="status-badge" [class]="'status-' + cert.status">
                        {{ cert.status === 'active' ? 'ใช้งาน' : 'หมดอายุ' }}
                      </span>
                      <span class="action-divider" aria-hidden="true"></span>
                      <button type="button" class="btn btn-icon" aria-label="ดูรายละเอียดใบรับรอง"
                              title="ดูรายละเอียด" (click)="viewCertificate(cert)">
                        <i class="bi bi-eye"></i>
                      </button>
                      @if (cert.certificateType == 'SELF_CREATED') {
                        <button type="button" class="btn btn-icon" aria-label="แก้ไขใบรับรอง" title="แก้ไข"
                                (click)="editCertificate(cert)">
                          <i class="bi bi-pencil"></i>
                        </button>
                        <button type="button" class="btn btn-icon text-danger" aria-label="ลบใบรับรอง" title="ลบ"
                                (click)="deleteCertificate(cert)">
                          <i class="bi bi-trash"></i>
                        </button>
                      }
                    </div>
                  </div>

                  <div class="certificate-meta-row">
                    <div class="meta-item">
                      <span class="meta-label">มาตรฐาน:</span>
                      <span class="meta-value">{{ cert.standardCode ? cert.standardCode + ' · ' : '' }}{{ cert.standardName }}</span>
                    </div>
                    @if (cert.productName) {
                      <div class="meta-item">
                        <span class="meta-label">ชื่อสินค้า:</span>
                        <span class="meta-value">{{ cert.productName }}</span>
                      </div>
                    }
                    @if (cert.attachmentUrl) {
                      <div class="meta-item">
                        <span class="meta-label">ไฟล์แนบ:</span>
                        <a class="meta-value" [href]="cert.attachmentUrl" target="_blank" rel="noopener">
                          <i class="bi bi-paperclip" aria-hidden="true"></i> {{ cert.attachmentName || 'ดูไฟล์' }}
                        </a>
                      </div>
                    }
                    <div class="meta-item">
                      <span class="meta-label">ระยะเวลารับรอง:</span>
                      <span class="meta-value">{{ formatDate(cert.startDate) }} – {{ formatDate(cert.endDate) }}</span>
                    </div>
                    @if (cert.sizeFarm != null) {
                      <div class="meta-item">
                        <span class="meta-label">ขนาดฟาร์ม:</span>
                        <span class="meta-value">{{ cert.sizeFarm }}{{ cert.unitFarm ? ' ' + cert.unitFarm : '' }}</span>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          </article>
        }
      </div>
    </div>
  }
</div>
